

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERCONNECTIONS= createAsyncThunk(
  "getUserConnections/getUserConnections",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserConnectionsSlice = createSlice({
  name: "getUserConnectionsSlice",
  initialState: {
    getUserConnections: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserConnections: (state) => {
        state.getUserConnections.loading = false
        state.getUserConnections.error = false
        state.getUserConnections.data = []
        state.getUserConnections.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERCONNECTIONS.fulfilled, (state, action) => {
      state.getUserConnections = {
        ...state.getUserConnections,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERCONNECTIONS.pending, (state, action) => {
      state.getUserConnections = {
        ...state.getUserConnections,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERCONNECTIONS.rejected, (state, action) => {
      state.getUserConnections = {
        ...state.getUserConnections,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserConnectionsAction = {
    GETUSERCONNECTIONS,
};

export { getUserConnectionsAction };
export default getUserConnectionsSlice.reducer;
export const {setInitialStateOfgetUserConnections} = getUserConnectionsSlice.actions